import ResourceTabSnippet from './ResourceTabSnippet.view';
export default ResourceTabSnippet;
